import {
    logDebug,
    logInfo,
    logWarn,
    logError,
    logEvent,
} from '../../tracing.js';

import { map } from 'lodash';
const _prefix = 'FBQ';

const _validateFbq = () => {
    if (!fbq) {
        throw new Error('fbq is null or undefined');
    }
};

const _validateFbqData = (prop) => {
    if (!window.facebookData) {
        throw new Error(`${_prefix} window.facebookData is not defined`);
    }
    if (!window.facebookData[prop]) {
        throw new Error(
            `${_prefix} ${prop} is not defined on window.facebookData`
        );
    }
};

const fbqPixelId = () => {
    _validateFbqData('pixelId');
    _validateFbqData('fbCulture');
    _validateFbq();
    logDebug(
        `PixelId: ${window.facebookData.pixelId} fbCulture: ${window.facebookData.fbCulture} `
    );
    logDebug('Firing pixelId', window.facebookData.pixelId);
    fbq('init', window.facebookData.pixelId);
};

const init = () => {
    //Facebook pixelId
    !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod
                ? n.callMethod.apply(n, arguments)
                : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    })(
        window,
        document,
        'script',
        'https://connect.facebook.net/en_US/fbevents.js'
    );
};

const addToCart = ({ isKit, id, quantity, currency, price, eventId }) => {
    _validateFbq();
    const addToCartObject = {
        content_name: isKit
            ? `${window.$pathBase}Cart/AddKitToCartNew`
            : `${window.$pathBase}Cart/AddProductToCartNew`,
        content_type: 'product',
        contents: [
            {
                id,
                quantity: Number(quantity),
            },
        ],
        currency: currency,
        value: price,
    };

    logEvent(`${_prefix} AddToCart Facebook`, addToCartObject);
    fbq('track', 'AddToCart', addToCartObject, { eventID: eventId });
};

const pageView = () => {
    _validateFbq();
    logEvent(`${_prefix} PageView Facebook`);
    fbq('track', 'PageView');
};

const beginCheckout = ({ currency, value, items, eventId }) => {
    logDebug('_sendFbqInitiateCheckout');
    _validateFbq();
    const initiateCheckoutData = {
        currency,
        value,
        num_items: items.length,
        contents: map(items, (item) => ({
            id: item.facebookId,
            quantity: item.quantity,
        })),
    };
    logEvent(`${_prefix} InitiateCheckout Facebook`, initiateCheckoutData);
    fbq('track', 'InitiateCheckout', initiateCheckoutData, {
        eventID: eventId,
    });
};

const newsletterRegistration = ({ url, email }) => {
    logDebug('_sendFbqRegistration');
    _validateFbq();
    const completeRegistrationObj = {
        status: true,
        content_name: url === undefined ? window.location.href : url,
        value: email,
    };
    logEvent(
        `${_prefix} CompleteRegistration Facebook`,
        completeRegistrationObj
    );
    fbq('track', 'CompleteRegistration', completeRegistrationObj);
};

const contact = () => {
    _validateFbq();

    logEvent(`${_prefix} Contact Facebook`);
    fbq('track', 'Contact');
};

const search = ({ searchterm }) => {
    _validateFbq();
    logEvent(`${_prefix} Search Facebook`, searchterm);
    fbq('track', 'Search', {
        search_string: searchterm,
    });
};

const addPaymentInfo = ({ currency, value, items, eventId }) => {
    _validateFbq();
    const paymentObj = {
        currency,
        value,
        contents: map(items, (item) => ({
            id: item.googleId,
            quantity: item.quantity,
        })),
    };
    logEvent(`${_prefix} AddPaymentInfo Facebook`, paymentObj);
    fbq('track', 'AddPaymentInfo', paymentObj, { eventID: eventId });
};

const viewItem = ({ slug, guid, options, currencyCode, isKit }) => {
    _validateFbq();
    fbqPixelId();
    const viewItemObject = {
        content_name: `${window.$pathBase}${slug}`,
        content_ids: isKit
            ? [`${guid}`]
            : map(options, (o) => `${guid}-${o.sourceId}`),
        currency: currencyCode,
    };
    logEvent(`${_prefix} ViewContent Facebook`, viewItemObject);
    fbq('track', 'ViewContent', viewItemObject);
};

const purchase = ({ currency, value, items, eventId }) => {
    _validateFbq();
    let purchaseData = {
        contents: items.map((li) => ({
            id: li.facebookId,
            quantity: li.quantity,
        })),
        content_type: 'product',
        value,
        currency,
    };
    logEvent(`${_prefix} Purchase Facebook`, purchaseData);
    fbq('track', 'Purchase', purchaseData, { eventID: eventId });
};

export {
    init,
    addToCart,
    fbqPixelId,
    pageView,
    beginCheckout,
    newsletterRegistration,
    contact,
    search,
    addPaymentInfo,
    viewItem,
    purchase,
};
